import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url, URLS } from '@wix/da-url';
import { BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { BiData } from '@wix/da-bi/pkg/events';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import { getStashFolder, getStashNext, getStashPrev } from '../../../../DeviationPage/redux/selectors';
import { useIsCurrentUserDeviationAuthor } from '../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useDeleteDeviationFlow } from '../../../actionHooks/useDeleteDeviationFlow';
import { useFreeDownloadAction } from '../../../buttons/DownloadButton/hooks';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { StashElementPlacementContext } from '../../../ElementPlacementContext/variants/stash/context';
import { useElementPlacementForArea } from '../../../ElementPlacementContext';
import { StashDeviationElementPlacement } from '../../../ElementPlacementContext/variants/stash/types';
import { useCopyLinkAction } from '../CopyLinkButton';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MuroDepContext } from '@wix/da-react-context/pkg/MuroDepContext';
import { usePushModal } from '../../../../utils/hooks/usePushModal';
import { ModalType } from '../../../../Modals/redux/types';
function useDeleteStashDeviationFlow(deviation) {
    let next = useSelector(getStashNext);
    let prev = useSelector(getStashPrev);
    next = next ? Url.stashItemLink(next) : undefined;
    prev = prev ? Url.stashItemLink(prev) : undefined;
    const folder = useSelector(getStashFolder);
    let toFolder = undefined;
    if (folder === null || folder === void 0 ? void 0 : folder.hasSubfolders) {
        toFolder = Url.stashFolderLink(folder.folderId);
    }
    var _ref, _ref1;
    return useDeleteDeviationFlow(deviation, {
        redirectTo: (_ref1 = (_ref = next !== null && next !== void 0 ? next : prev) !== null && _ref !== void 0 ? _ref : toFolder) !== null && _ref1 !== void 0 ? _ref1 : URLS.STASH,
        supportTierDeletion: false
    });
}
const MoreButton = ({ deviation, className })=>{
    const isMiniMuro = useFlag('mini_muro');
    const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
    const isMobile = useContext(MobileContext);
    const placementMapForMenu = useElementPlacementForArea(StashDeviationElementPlacement.PrimaryBarMenu, StashElementPlacementContext);
    const { t } = useTranslation();
    const pushMuroModal = usePushModal(ModalType.MINI_MURO);
    const { enactFlow: enactDeleteFlow, biData: deleteFlowBiData, supportingComponents: deleteFlowSupportingComponents } = useDeleteStashDeviationFlow(deviation);
    const freeDownloadAction = useFreeDownloadAction(deviation, isAuthor);
    const [onCopyLinkClick, copyLinkBiData] = useCopyLinkAction(deviation);
    const { MiniComponent } = useContext(MuroDepContext);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        size: "medium",
        icon: EllipsisIcon,
        placement: "top-start",
        tooltipText: !isMobile && t('actionbar.more.tooltip'),
        "aria-label": t('actionbar.more'),
        className: className,
        biData: BiData({
            evid: 417,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            sectionname: 'stash-deviation'
        }),
        items: [
            placementMapForMenu.deleteDeviation && {
                label: t('actionbar.delete'),
                biData: deleteFlowBiData,
                onClick: enactDeleteFlow
            },
            placementMapForMenu.copyLink && {
                label: t('actionbar.stash.copyLink.button.label'),
                biData: copyLinkBiData,
                onClick: onCopyLinkClick
            },
            placementMapForMenu.freeDownload && freeDownloadAction.hasAction && {
                label: t('actionbar.download'),
                link: freeDownloadAction.href,
                onClick: freeDownloadAction.onClick,
                biData: BiData({
                    evid: 350,
                    ispaiddownload: 0,
                    deviationid: deviation.deviationId,
                    sectionname: 'action_bar'
                })
            },
            !isMiniMuro && placementMapForMenu.muroImport && deviation.extended && {
                label: t('actionbar.muro.import'),
                link: deviation.extended.muroImportUrl,
                biData: BiData({
                    evid: 926,
                    deviationid: deviation.deviationId,
                    sectionname: BiContextProvidedValue
                })
            },
            !isMiniMuro && placementMapForMenu.muroOpen && deviation.extended && {
                label: t('actionbar.muro.edit'),
                link: deviation.extended.muroOpenUrl,
                biData: BiData({
                    evid: 926,
                    deviationid: deviation.deviationId,
                    sectionname: BiContextProvidedValue
                })
            },
            isMiniMuro && deviation.extended && {
                label: t('actionbar.draw.edit'),
                onClick: ()=>{
                    if (MiniComponent) {
                        pushMuroModal({
                            miniComponent: MiniComponent,
                            deviation: deviation
                        });
                    }
                }
            }
        ]
    }), deleteFlowSupportingComponents);
};
MoreButton.displayName = 'MoreButton';
export default MoreButton;

//# sourceMappingURL=MoreButton.js.map